// extracted by mini-css-extract-plugin
module.exports = {"margin_left_20":"ScreeningQuestion_margin_left_20__3EPBn"};